<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveMedicineCourse">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Schmerzverlauf erstellen</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body class="example-card scrollbar-blue thin">
            <validation-provider
              name="Datum"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-date-picker
                v-model="datum"
                disabledFuture
                label="Datum"
                name="Datum"
                :option="optionDatePicker"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                outline
                @getValue="getPickersValue"
              />
            </validation-provider>
            <validation-provider
              name="Uhrzeit"
              rules="required"
              v-slot="{ errors, valid, invalid }"
              slim
            >
              <mdb-time-picker
                id="uhrzeit"
                v-model="uhrzeit"
                label="Uhrzeit"
                name="Uhrzeit"
                :hours-format="24"
                class="mb-0"
                outline
                :done-label="optionTimePicker.done"
                :closeLabel="optionTimePicker.cancel"
                :clearLabel="optionTimePicker.clear"
                @getValue="verifyValue"
              />
              <span v-if="valid" class="valid-feedback d-block">sieht gut aus</span>
              <span v-if="invalid" class="invalid-feedback d-block">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider
              name="Nicht mehr aufgetreten seit"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <label>Intensitaet</label>
              <mdb-rating
                v-model="form.Intensitaet"
                far
                :options="rateOptions"
                :activeFar="false"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
              />
            </validation-provider>
            <label class="mb-0 mt-4">Beurteilung BESD</label>
            <validation-provider
              name="Atmung"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
              >
              <mdb-select
                outline
                id="beurteilung_atmung"
                v-model="AtmungArray"
                label="Atmung auswählen"
                name="Atmung"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                @getValue="setAtmungValue"
              />
            </validation-provider>
            <validation-provider
              name="Negative Lautäußerung"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-select
                outline
                id="Negative_Lautaeuberung"
                v-model="Negative_Lautaeuberung_Array"
                label="Negative Lautäußerung auswählen"
                name="Negative Lautäußerung"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                @getValue="setNegativeValue"
              />
            </validation-provider>
            <validation-provider
                name="Gesichtsausdruck"
                rules="required"
                v-slot="{ errors, valid, validated }"
                slim
              >
                <mdb-select
                  outline
                  id="schicht"
                  v-model="GesichtsausdruckArray"
                  label="Gesichtsausdruck auswählen"
                  name="Gesichtsausdruck"
                  :customValidation="validated"
                  :isValid="valid"
                  :invalidFeedback="errors[0]"
                  validFeedback="sieht gut aus"
                  @getValue="setGesichtsausdruckValue"
                />
            </validation-provider>
            <validation-provider
              name="Koerpersprache"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
              >
              <mdb-select
                outline
                id="Beurteilung_Koerpersprache"
                v-model="KoerperspracheArray"
                label="Koerpersprache auswählen"
                name="Koerpersprache"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                @getValue="setKoerperspracheValue"
              />
            </validation-provider>
            <validation-provider
              name="Trost"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
              >
              <mdb-select
                outline
                id="trost"
                v-model="TrostArray"
                label="Trost auswählen"
                name="Trost"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                @getValue="setTrostValue"
              />
            </validation-provider>
            <validation-provider
              name="Kommentar"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                v-model="form.Kommentar"
                type="textarea"
                :rows="5"
                label="Kommentar"
                name="Kommentar"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                outline
              />
            </validation-provider>
          </mdb-modal-body>
          <mdb-modal-footer>
              <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
              <mdb-btn
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import utils from '@/mixins/Utils'
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbSelect,
    mdbDatePicker,
    mdbTimePicker,
    mdbIcon,
    mdbRating,
    mdbInput
  } from 'mdbvue';

  export default {
    name: 'AddPainLevelCourseModal',
    mixins: [utils()],
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbSelect,
      mdbDatePicker,
      mdbTimePicker,
      mdbIcon,
      mdbRating,
      mdbInput
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      SchmerzkurveId: {
        type: [Number, String],
        default: 0
      }
    },

    data() {
      return {
        modal: false,
        loading: false,
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        form: {
          Key: '',
          Datum: '',
          Intensitaet: 0,
          Intensitaet_BESD: 0,
          Atmung: '',
          Negative_Lautaeuberung: '',
          Gesichtsausdruck: '',
          Koerpersprache: '',
          Trost: '',
          Kommentar: '',
          AenderungVon: '',
          AenderungAm: '',
        },
        defaultForm : {
          Key: '',
          Datum: '',
          Intensitaet: 0,
          Intensitaet_BESD: 0,
          Atmung: '',
          Negative_Lautaeuberung: '',
          Gesichtsausdruck: '',
          Koerpersprache: '',
          Trost: '',
          Kommentar: '',
          AenderungVon: '',
          AenderungAm: '',
        }
      }
    },

    computed: {
      selectedData() {
        let response = this.lagerungsartOptions.find(option => {
          return option.selected === true
        });
        if (response) {
          return response.value
        }
        return ""
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
      SchmerzkurveId (v) {
        this.form.Key = v
      }
    },

    created() {
      this.form.Key = this.SchmerzkurveId
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.AtmungArray.find(option => {
          option.selected = false
        })
        this.Negative_Lautaeuberung_Array.find(option => {
          option.selected = false
        })
        this.GesichtsausdruckArray.find(option => {
          option.selected = false
        })
        this.KoerperspracheArray.find(option => {
          option.selected = false
        })
        this.TrostArray.find(option => {
          option.selected = false
        })
        this.$emit('close')
      },

      save () {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      setAtmungValue (value) {
        this.form.Atmung = value
      },

      setNegativeValue (value) {
        this.form.Negative_Lautaeuberung = value
      },

      setGesichtsausdruckValue (value) {
        this.form.Gesichtsausdruck = value
      },

      setKoerperspracheValue (value) {
        this.form.Koerpersprache = value
      },

      setTrostValue (value) {
        this.form.Trost = value
      },

      verifyValue() {
        const time = document.getElementById('uhrzeit')
        if(time) {
          if(this.uhrzeit === '' || this.uhrzeit === undefined) {
            time.classList.add('is-invalid')
            time.classList.remove('is-valid')
          }else {
            time.classList.add('is-valid')
            time.classList.remove('is-invalid')
          }
        }
      },

      saveMedicineCourse() {
        // time picker validation check
        this.verifyValue()


        this.form.Datum = this.formatDateY(this.datum)
        this.form.Datum = this.serverDateFormat(new Date(this.form.Datum+' '+this.uhrzeit))
        this.form.AenderungVon = this.loginUser.username
        this.form.AenderungAm = this.form.Datum
        this.form.Key = this.SchmerzkurveId

        let atmung = this.form.Atmung!== '' ? parseInt(this.form.Atmung) : 0
        let negative_Lautaeuberung = this.form.Negative_Lautaeuberung!== '' ? parseInt(this.form.Negative_Lautaeuberung) : 0
        let gesichtsausdruck = this.form.Gesichtsausdruck!== '' ? parseInt(this.form.Gesichtsausdruck) : 0
        let koerpersprache = this.form.Koerpersprache!== '' ? parseInt(this.form.Koerpersprache) : 0
        let trost = this.form.Trost!== '' ? parseInt(this.form.Trost) : 0

        this.form.Intensitaet_BESD = atmung + negative_Lautaeuberung + gesichtsausdruck +
                              koerpersprache + trost

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('/Schmerzverlauf', this.form)
            .then(res => {
              if(res.data) {
                  this.$notify.success({message: 'Schmerzverlauf erstellen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
                  this.save()
              }else {
                  this.$notify.error({message: 'Gescheitert Schmerzverlauf erstellen!!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .catch((error) => {
              this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
            })
            .finally(() => {
              this.loading = false
            })

          // Wait until the models are updated in the UI
          this.$nextTick(() => {
            this.$refs.form.reset()
          });
        });
      }
    }
  }
</script>
